import React from 'react';
import PropTypes from 'prop-types';
import { FiFile, FiTrash2, FiEye } from 'react-icons/fi';
import StatusBadge from '../common/StatusBadge';
import { formatDate } from '../../utils/formatters';
import { DOCUMENT_TYPES } from '../../utils/constants';
import './DocumentList.css';

const DocumentList = ({ documents = [], onView, onDelete }) => {
  if (documents.length === 0) {
    return (
      <div className="document-list--empty">
        <p>No documents uploaded yet.</p>
      </div>
    );
  }

  const formatSize = (bytes) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className="document-list">
      <ul className="doc-items">
        {documents.map(doc => {
          const typeLabel = DOCUMENT_TYPES[doc.type] || doc.type;
          const isVerified = doc.status === 'VERIFIED';
          
          return (
            <li key={doc.id} className="doc-item-row">
              <div className="doc-icon">
                <FiFile />
              </div>
              
              <div className="doc-info">
                <div className="doc-info__header">
                  <span className="doc-type-label">{typeLabel}</span>
                  <StatusBadge status={doc.status} />
                </div>
                <div className="doc-name">{doc.filename}</div>
                <div className="doc-meta">
                  <span>{formatDate(doc.uploadedAt)}</span>
                  <span>&bull;</span>
                  <span>{formatSize(doc.size)}</span>
                </div>
              </div>

              <div className="doc-actions">
                <button 
                  className="btn-icon" 
                  onClick={() => onView(doc)}
                  title="View Document"
                  aria-label={`View ${doc.filename}`}
                >
                  <FiEye />
                </button>
                
                {!isVerified && (
                  <button 
                    className="btn-icon btn-icon--danger" 
                    onClick={() => onDelete(doc.id)}
                    title="Delete Document"
                    aria-label={`Delete ${doc.filename}`}
                  >
                    <FiTrash2 />
                  </button>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

DocumentList.propTypes = {
  documents: PropTypes.array.isRequired,
  onView: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default DocumentList;
